// @flow strict-local
import * as React from 'react';

import logger from 'src/utils/logger';

import type {SchedulerTemplates} from 'src/types/scheduler';

import {useMultiEventChatbotMeetingNodes} from 'src/hooks/product-flags';

import {useApi, useAdvancedApi, type ApiState, type BaseApiOptions} from '../useApi';


export function useSchedulerTemplates(
  deps?: BaseApiOptions | mixed[],
): ApiState<SchedulerTemplates> {
  return useApi<SchedulerTemplates>('scheduler/event-templates', deps);
}

export function useSchedulerTeamTemplates(
  deps?: BaseApiOptions | mixed[],
): ApiState<SchedulerTemplates> {
  return useApi<SchedulerTemplates>('scheduler/event-templates/team', deps);
}

/**
 * Fetch templates for chatbot flows (may include team, multi-event, etc templates)
 * based on release flags and agency configuration.
 *
 * @return {[SchedulerTemplate]} an array of scheduler templates
 */
export function useChatbotSchedulerTemplates(): SchedulerTemplates {
  const [templates, setTemplates] = React.useState<SchedulerTemplates>([]);

  const handleResponse = (templates: SchedulerTemplates) =>
    setTemplates((prev) => {
      return [...prev, ...templates];
    });
  const fetchMultiEventTemplates = useMultiEventChatbotMeetingNodes();

  useAdvancedApi<SchedulerTemplates>('scheduler/event-templates/team', {
    handleResponse,
  });
  useAdvancedApi<SchedulerTemplates>(
    fetchMultiEventTemplates
      ? {
          pathname: 'scheduler/event-templates',
          query: {distribution_rule: 'one_slot_multiple_event'},
        }
      : null,
    {
      handleResponse,
      handleError: (err) => {
        logger.error(
          'cannot fetch multi event templates because user is not permitted',
          err,
        );
      },
      deps: [fetchMultiEventTemplates],
    },
  );

  return templates;
}
